import {Message} from 'element-ui'
let msgIns = null;
const resetMsg = (options) => {
    if (msgIns)
        msgIns.close();
    //msgIns = Message(options)
    msgIns = Message({...options, offset: 80})
  };

  ['success', 'warning', 'info', 'error'].forEach(type => {
    resetMsg[type] = options => {
      if (typeof options === 'string') {
        options = {message: options,};
      }
      options.type = type;
      return resetMsg(options);
    };
  });
  export const message = resetMsg


  


// WEBPACK FOOTER //
// ./src/utils/msg.js